// extracted by mini-css-extract-plugin
export default {"btn":"SliderButton_btn__ViLw4","next":"SliderButton_next__J6+6m","prev":"SliderButton_prev__-g4sI"};